import * as types from '../../constants/wallet/walletConstants';

export const dashboardSummary = () => ({
  type: types.DASHBOARD_SUMMARY_REQUEST,
});

export const setDashboardSummary = (data) => ({
  type: types.SET_DASHBOARD_SUMMARY,
  data,
});

export const dashboardAvailableBalance = (beginDate, endDate, hourly) => ({
  type: types.DASHBOARD_AVAILABLE_BALANCE_REQUEST,
  beginDate,
  endDate,
  hourly,
});

export const setDashboardAvailableBalance = (data) => ({
  type: types.SET_DASHBOARD_AVAILIABLE_BALANCE,
  data,
});

export const dashboardMinting = (beginDate, endDate) => ({
  type: types.DASHBOARD_MINTING_REQUEST,
  beginDate,
  endDate,
});

export const setDashboardMinting = (data) => ({
  type: types.SET_DASHBOARD_MINTING,
  data,
});

export const dashboardUsageAndDestroy = (beginDate, endDate) => ({
  type: types.DASHBOARD_USAGE_AND_DESTROY_REQUEST,
  beginDate,
  endDate,
});

export const setDashboardUsageAndDestroy = (data) => ({
  type: types.SET_DASHBOARD_USAGE_AND_DESTROY,
  data,
});

export const notificationSettingInfo = () => ({
  type: types.NOTIFICATION_SETTING_INFO_REQUEST,
});

export const setNotificationSettingInfo = (data) => ({
  type: types.SET_NOTIFICATION_SETTING_INFO,
  data,
});

export const notificationSettingUpdate = (
  xperDailyMinimumAlarm,
  perDailyMinimumAlarm,
  hvhDailyMinimumAlarm,
  xperDailyMaximumAlarm,
  perDailyMaximumAlarm,
  hvhDailyMaximumAlarm,
  xperRealtimeMinimumAlarm,
  perRealtimeMinimumAlarm,
  hvhRealtimeMinimumAlarm,
) => ({
  type: types.NOTIFICATION_SETTING_UPDATE,
  xperDailyMinimumAlarm,
  perDailyMinimumAlarm,
  hvhDailyMinimumAlarm,
  xperDailyMaximumAlarm,
  perDailyMaximumAlarm,
  hvhDailyMaximumAlarm,
  xperRealtimeMinimumAlarm,
  perRealtimeMinimumAlarm,
  hvhRealtimeMinimumAlarm,
});

export const tokenSendConditionsInfo = () => ({
  type: types.TOKEN_SEND_CONDITIONS_INFO_REQUEST,
});

export const setTokenSendConditionsInfo = (data) => ({
  type: types.SET_TOKEN_SEND_CONDITIONS_INFO,
  data,
});

export const tokenSendConditionsUpdate = (
  xperTransferLimit,
  perTransferLimit,
  hvhMinimumWithdrawalBalance,
  hvhTransferAccount,
  xperUserOnetimeTransferLimit,
  perUserOnetimeTransferLimit,
  xperUserDailtyTransferLimit,
  perUserDailtyTransferLimit,
) => ({
  type: types.TOKEN_SEND_CONDITIONS_UPDATE,
  xperTransferLimit,
  perTransferLimit,
  hvhMinimumWithdrawalBalance,
  hvhTransferAccount,
  xperUserOnetimeTransferLimit,
  perUserOnetimeTransferLimit,
  xperUserDailtyTransferLimit,
  perUserDailtyTransferLimit,
});

export const xperMint = (xperQuantity, twofaNo) => ({
  type: types.XPER_MINT,
  xperQuantity,
  twofaNo,
});

export const setWalletResponseMessage = (resultCode) => ({
  type: types.WALLET_RESPONSE_MESSAGE,
  resultCode,
});
